<template>
  <div
    class="start-widget"
    :class="{
      'start-widget--logged-in': showScreen === 'store',
      'start-widget--error':  showScreen === 'error',
      'start-widget--more':  showScreen === 'result'
    }"
    ref="scroll">
    <div
      class="chopstick-loader"
      :class="{
        'chopstick-loader--active': loading
        }">
			<img src="files/loasia/icons/choploader.gif" class="chopstick-loader__gif" alt="loader">
    </div>
    <div class="start-widget__container">
      <!-- First Screen-->
      <template v-if="showScreen === 'editzip'">
        <div class="lo-input" :class="{'empty': emptyZip}" v-bind:style="styleObject">
          <input
            v-model="zip"
            type="tel"
            class="lo-input__field"
            placeholder="."
            autocomplete="off"
            maxlength="4"
            @keydown="onZipKeydown"
          />
          <label class="lo-input__label">{{$t('zipwidgetpage.plz')}}
          </label>
          <span class="lo-input__error">{{$t('zipwidgetpage.falsePostCode')}}</span>
        </div>
        <span class="lo-smallhint"><a v-bind:href="$t('zipwidgetpage.courierListSlug')">{{$t('zipwidgetpage.noPostCode')}}</a></span>
        <div class="lo-choice-btns">
          <div class="lo-choice-btns__single lo-choice-btns__single--radio" :class="{'lo-choice-btns__single--active': deliveryType == 'delivery'}" @click.prevent="deliveryType = 'delivery'">
            <input type="radio" id="delivery" class="radio">
            <label for="delivery" class="label">{{$t('zipwidgetpage.deliveryButton')}}</label>
          </div>
          <div class="lo-choice-btns__single lo-choice-btns__single--radio" :class="{'lo-choice-btns__single--active': deliveryType == 'takeaway'}" @click.prevent="deliveryType = 'takeaway'">
            <input type="radio" id="takeaway" class="radio">
            <label for="takeaway" class="label">{{$t('zipwidgetpage.pickupButton')}}</label>
          </div>
        </div>
        <OrderButton
          :text="$t('zipwidgetpage.orderButton')"
          @click="onOrder"
        />
        <div class="roller-driver">
          <img src="/files/loasia/icons/roller-driver.svg" alt="roller-driver" />
        </div>
      </template>

      <template v-if="showScreen === 'editzip' && zip === '' ">
        <div class="prompt">
          <div class="prompt__text">{{$t('zipwidgetpage.promptText')}}</div>
        </div>
      </template>

      <!-- Error Screen-->
      <template v-if="showScreen === 'error'">
        <div class="start-widget__error-msg">
          <div>{{$t('zipwidgetpage.error')}}</div>
        </div>
        <div class="start-widget__error-msg-text">{{errorMsg}}</div>

        <div class="start-widget__return">
          <BackButton :text="$t('zipwidgetpage.backButton')" @click="goBack"/>
        </div>
      </template>

      <!-- Temp Closed Screen-->
      <template v-if="showScreen === 'closed'">
        <div class="start-widget__error-msg">
          <div>{{$t('zipwidgetpage.closedText')}}</div>
        </div>
        <div class="start-widget__error-msg-text">{{tempClosedMessage}}</div>

        <div class="start-widget__return">
          <BackButton :text="$t('zipwidgetpage.backButton')" @click="onTempClosedClose"/>
        </div>
      </template>

      <!-- User Logged in Screen with cart-->
      <template v-if="showScreen === 'store'">
        <div class="start-widget__welcome">
          <span>{{$t('zipwidgetpage.hello')}} {{accountFirstName}}</span>
        </div>
        <table class="lo-widget-table">
          <tbody class="lo-widget-table__body">
          <tr class="lo-widget-table__row">
            <td class="td-first">{{$t('zipwidgetpage.yourCourier')}}</td>
            <td class="td-last">{{$t('zipwidgetpage.type')}}</td>
          </tr>
          <tr class="lo-widget-table__row lo-widget-table__row--bold">
            <td class="td-first">{{cartStoreName}}</td>
            <td class="td-last">{{$t( cartDeliveryType === 'takeaway' ? 'zipwidgetpage.pickupType' : 'zipwidgetpage.deliveryType' )}}</td>
          </tr>
          </tbody>
        </table>
        <BackButton :text="$t('zipwidgetpage.changeButton')" @click="changeStore"/>

        <OrderButton :text="$t('zipwidgetpage.orderButton')" @click="onContinueOrder"/>
      </template>

      <!-- User Logged in Screen-->
      <template v-if="showScreen === 'account'">
        <div class="start-widget__welcome">
          <span>{{$t('zipwidgetpage.hello')}} {{accountFirstName}}</span>
        </div>
        <table class="lo-widget-table">
          <tbody class="lo-widget-table__body">
          <tr class="lo-widget-table__row">
            <td class="td-first">{{$t('zipwidgetpage.yourCourier')}}</td>
            <td class="td-last">{{$t('zipwidgetpage.type')}}</td>
          </tr>
          <tr class="lo-widget-table__row lo-widget-table__row--bold">
            <td class="td-first">{{accountAddress.store.name}}</td>
            <td class="td-last">{{$t( cartDeliveryType === 'takeaway' ? 'zipwidgetpage.pickupType' : 'zipwidgetpage.deliveryType' )}}</td>
          </tr>
          </tbody>
        </table>
        <BackButton :text="$t('zipwidgetpage.changeButton')" @click="changeStore"/>

        <OrderButton :text="$t('zipwidgetpage.orderButton')" @click="onAccountOrder"/>
      </template>

      <!-- Location Found Screen-->
      <template v-if="showScreen === 'result'">
        <div
          v-if="!noLocation"
          class="start-widget__welcome"
        >
          <span>{{$t('zipwidgetpage.moreLocation')}}</span>
        </div>
        <div v-else-if="deliveryType === 'delivery'" class="start-widget__welcome">
          {{$t('zipwidgetpage.noLocation')}}
        </div>
        <div v-else-if="deliveryType === 'takeaway'" class="start-widget__welcome">
          {{$t('zipwidgetpage.noTakeaway')}}
        </div>
        <div v-if="deliveryType === 'delivery'" class="order-by-phone">
          <a class="order-by-phone__text" v-bind:href="$t('zipwidgetpage.courierListSlug')"> {{$t('zipwidgetpage.allCouriers')}}</a>
        </div>
        <div class="start-widget__return">
          <BackButton :text="$t('zipwidgetpage.backButton')" @click="goBack"/>
        </div>
        <template
          v-if="!noLocation"
        >
          <a
            v-for="location in locations"
            :key="location.store_id"
            @click.prevent="onLocationListChoose(location)"
            href="javascript:void(0)"
            class="lo-icon-btn lo-icon-btn--sm-icon-text"
          >
            <span class="lo-icon-btn__text">
              {{location.store_name}}
            </span>
            <SVGArrowCircle/>
          </a>
        </template>

        <div v-if="noLocation && deliveryType === 'takeaway'" class="order-by-phone">
          <a
            v-for="location in locationsOpen"
            :key="location.store_id"
            @click.prevent="onNoLocationListChoose(location)"
            href="javascript:void(0)"
            class="lo-icon-btn lo-icon-btn--sm-icon-text"
          >
            <span class="lo-icon-btn__text">
              {{location.store_name}}</span>
            <SVGArrowCircle/>
          </a>
        </div>

      </template>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import BackButton from '@/components/BackButton'
  import OrderButton from '@/components/OrderButton'
  import {trackEvent} from '@/helpers/gtm'

  export default {
    components: {
      BackButton,
      OrderButton
    },
    props: {
      cls: {}
    },
    data() {
      return {
        loading: false,
        zipRegex: /^([1-468][0-9]|[57][0-7]|9[0-6])[0-9]{2}$/,
        zip: '',
        tempClosedMessage: '',
        showTempClosed: false,
        showResult: false,
        changeZip: false,
        noLocation: false,
        deliveryType: "delivery", //pickup
        error: false,
        isDisabled: false,
        show: true,
        selected: undefined,
        emptyZip: false
      }
    },
    computed: {
      ...mapGetters('location', ['locations', 'locationsOpen']),
      ...mapGetters('cart', ['cartStoreName', 'hasCart', 'cartDeliveryType']),
      ...mapGetters('account', ['accountFirstName', 'accountLoggedIn', 'accountLastOrder', 'accountAddress']),
      showScreen() {
        if (this.showTempClosed) {
          return 'closed'
        } else if (this.error) {
          return 'error'
        } else if (this.hasCart && !this.changeZip) {
          return 'store'
        } else if (this.accountLoggedIn && this.accountAddress && !this.changeZip) {
          return 'account'
        } else if (this.showResult) {
          return 'result'
        } else {
          return 'editzip'
        }
      },
      styleObject() {
        return {
          "--string-name": `'${this.$t('zipwidgetpage.falsePostCode')}'`
        }
      },
      errorMsg() {
        return `${this.$t('zipwidgetpage.errorMsg')}`
      }
    },
    methods: {
      trackEvent,
      async onContinueOrder() {
        trackEvent('Widget-Orderbutton-Saveddata', 'Klick', '')
        this.$store.dispatch('redirectToExistingCart')
      },
      async onAccountOrder() {
        trackEvent('Widget-Orderbutton-Accountdata', 'Klick', '')
        // HACK: currently we default to delivery
        this.$store.dispatch('redirectToDefaultStore', { deliveryType: this.cartDeliveryType })
      },
      async onOrder() {
        // validate input
        if (this.zipRegex.test(this.zip) && this.deliveryType != null) {
          this.loading = true
          this.emptyZip = false

          try {
            trackEvent('Widget-Orderbutton', 'Klick', `${this.zip},${this.deliveryType}`)
            await this.$store.dispatch("location/searchZip", {zip: this.zip, orderType: this.deliveryType})
            if (this.locations.length === 1) {
              // if there is only one location, redirect
              this.chooseLocation(this.locations[0])
            } else {
              this.loading = false
              this.showResult = true
              this.$nextTick(v => this.scrollToTop())
            }
          } catch (err) {
            // TODO: maybe there is an error we need to handle
            if (err.message != null) {
              this.error = err.message
            } else {
              //await this.$store.dispatch("location/loadAll")
              this.noLocation = true
              this.showResult = true
              this.$nextTick(v => this.scrollToTop())
            }
            this.loading = false
          }
        } else if (this.zip === '') {
          this.noZip()
        } else {
          this.error = true
        }
      },
      noZip() {
        this.emptyZip = true
      },
      onZipKeydown(e) {
        if (e.key === 'Enter') {
          this.onOrder()
        }
        this.emptyZip = false
      },
      scrollToTop() {
        this.$refs.scroll.scrollTop = 0
      },
      goBack() {
        this.showResult = false
        this.error = false
        this.noLocation = false
      },
      onLocationListChoose(location) {
        trackEvent('Widget-Multiple-Couriers', 'Klick', `${location.store_name},${this.deliveryType}`)
        this.chooseLocation(location)

      },
      onNoLocationListChoose(location) {
        trackEvent('Widget-Multiple-Couriers', 'Klick', `${location.store_name},takeaway`)
        this.chooseLocation(location, 'takeaway')
      },
      chooseLocation(location, deliveryType = null) {
        if (!deliveryType) {
          deliveryType = this.deliveryType
        }
        if (location.store_temporaryclosed === '1') {
          this.tempClosedMessage = location.store_temporarycloseddesc
          this.showTempClosed = true
          this.loading = false
        } else {
          const url = location[`storeUrl_${deliveryType}`]
          this.$store.dispatch('redirect', {name: 'toStore', url})
        }
      },
      onTempClosedClose() {
        this.tempClosedMessage = ''
        this.showTempClosed = false
      },
      changeStore() {
        this.changeZip = true
      },
    }
  }
</script>

<style></style>
